import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useFoetalObservations = (consultationId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["foetalObservations", consultationId, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/antenatalconsultationfoetalobservation/consultation/${consultationId}`
      );
      return response.data?.data ?? response.data;
    },
    enabled: !!consultationId && !!tenantVal,
  });
};
